/**
 * @ Summary: This component is utilized for listing the all WorkOrder Reports in the grid.
 */
import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  IconButton,
  CircularProgress,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  ListItemText,
  Checkbox,
  OutlinedInput,
  styled,
  Radio, RadioGroup, FormControlLabel,
} from "@mui/material";
import React, { useEffect, useMemo, useState, useRef } from "react";
import LoopRoundedIcon from "@mui/icons-material/LoopRounded";
import Tooltip from "@mui/material/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import commonMasterRepository from "../../api/repositories/commonMasterRepository";
import UserRepository from "../../api/repositories/userRepository";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import "../../assets/css/reports.css";
import moment from "moment";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import reportslogo from "../../assets/images/reportslogo.png";
import { updateFilterDetails } from "../../redux/actions/assetActions";
import WorkorderFinalreport from "../commoncomponents/WorkorderFinalreport";
import AssetRepository from "../../api/repositories/assetRepository";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import PageTitle from "../commoncomponents/PageTitle";
import WorkOrderRefreshExportButtons from "./WorkOrderRefreshExportButtons";
import utils from "../../utility/utilities";
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";
import { getFacilityId } from "../../utility/tokenUtility";
import PageLoader from "../commoncomponents/PageLoader";
import CustomMultiSelect from "../commoncomponents/CustomMultiSelect";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const StyledHelperText = styled(Typography)(({ theme }) => ({
  fontSize: "11px",
  marginLeft: "12px",
  marginTop: "3px",
  fontFamily: "DM Sans,sans-serif",
  lineHeight: 1.66,
  textAlign: "left",
  color: theme.palette.text.secondary,
  "&.error": {
    color: theme.palette.error.main,
  },
}));

const Reports = ({

}) => {
  const [commonTableLabel, setcommonTableLabel] = useState(null);
  const [servicelevel, setServiceLevel] = useState('')
  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA001");

  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null); // Tracks the selected value
  const [dateOption, setDateOption] = useState("");
  const [data, setData] = useState([]);
  const [leveldata, setLeveldata] = useState([]);
  const [history, setHistory] = useState([]);
  const [historyApiFilterData, setHistoryApiFilterData] = useState([]);
  const [canGoBack, setCanGoBack] = useState(false);
  const [adtionalcolumnDetailsThirdLevel, setAdtionalcolumnDetailsThirdLevel] = useState([]);
  const gridRef = useRef(null);
  const [lastApiParams, setLastApiParams] = useState(null); // Add this state to store last API call parameters
  const dispatch = useDispatch();
  const [level, setLevel] = useState(1);
  const [workOrderStatus, setWorkOrderStatus] = useState("");
  let filterDetails = useSelector((state) => state.workorderfilterDetails);
  const [filterDetailsData, setFilterDetailsData] = useState(filterDetails);
  const getLevel4Data = useSelector((state) => state.workOrderReducer.sections);
  const [pagination, setPagination] = useState(true);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const currentDate = utils.getCurrentDateFormatted("DD-MM-YYYY");
  const facilityId = getFacilityId("facilityid");
  const userid = localStorage.getItem("UserId");
  const facilityName = localStorage.getItem('FacilityName');

  // Filter details
  const handleOnChange = (name, value) => {
    let updatedFilterDetails = { ...filterDetailsData };

    if (name === "hospitalName") {
      updatedFilterDetails[name] = value?.value;
      updatedFilterDetails["hospitalid"] = value?.id; // Assign hospital ID
    } else if (name === "options") {
      updatedFilterDetails[name] = value; // Assign value for other fields
      if (value?.value === 2) {
        updatedFilterDetails["groupBy"] = { label: "All", value: 6 };
        setErrors((prevErrors) => ({
          ...prevErrors,
          options: "",
          groupBy: ""
        }));
      } else {
        updatedFilterDetails["groupBy"] = { label: "", value: "" };

      }
    } else if (name === "fromDate" || name === "toDate") {
      updatedFilterDetails[name] = value; // Directly assign date
    } else if (name === "workordercategory") {
      updatedFilterDetails[name] = value?.value;
      // Update dateOption based on the selected work order
      if (value?.label === "All") {
        setDateOption(""); // Reset date option for "All"
      } else if (value?.label === "Unscheduled") {
        setDateOption("Work order Date"); // Set to "Work order Date"
      } else if (value?.label === "Scheduled") {
        setDateOption("Target Date"); // Set to "Target Date"
      }


      if (filterDetailsData?.options?.id === 1 && value?.value === 3) {
        updatedFilterDetails["groupBy"] = { label: "All", value: 6 };
        setErrors((prevErrors) => ({
          ...prevErrors,
          groupBy: ""
        }));
      } else if (filterDetailsData?.options?.id === 1) {
        updatedFilterDetails["groupBy"] = "";
      }

    } else if (name === "priority") {
      updatedFilterDetails[name] = value?.value; // Correctly set the priority value
    } else if (name === "groupBy") {
      updatedFilterDetails[name] = value; // Assign value for other fields
    }
    else {

      updatedFilterDetails[name] = value?.value; // Assign value for other fields
    }
    setFilterDetailsData(updatedFilterDetails);

    // Validate the updated field and set errors
    const errorMessage = validateFieldSelectFields(value?.value || value, name);
    setErrors((prevErrors) => ({ ...prevErrors, [name]: errorMessage }));
  };

  const handleMultiSelectChange = (name, newValue) => {
    let selectedObjects;
    if (newValue.includes(12)) {
      // If "All" is selected, check if other options exist
      if (newValue.length === 1) {
        // Only "All" is selected
        setFilterDetailsData((prev) => ({
          ...prev,
          [name]: woType, // Set all options
        }));
      } else {
        // If "All" is selected along with others, deselect all others and keep only "All"
        setFilterDetailsData((prev) => ({
          ...prev,
          [name]: [], // Set all options
        }));
        // newValue = [12]; 
      }
    } else if (newValue.length === 0) {
      // If "All" and all options are deselected, reset to an empty array
      setFilterDetailsData((prev) => ({
        ...prev,
        [name]: [],
      }));
    } else {
      // If "All" is deselected, filter only selected options
      selectedObjects = woType.filter((item) => newValue.includes(item.id));
      setFilterDetailsData((prev) => ({
        ...prev,
        [name]: selectedObjects,
      }));
    }


    // Clear errors for this field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const hiddenFields = ["typecodeId", "hospitalCode", "workOrderId", "workGroupId", "assetId", "typeCodeId", "departmentId", "workOrderDate1"];
  const columns =
  data?.length > 0
    ? [
        // NO column
        {
          field: "no",
          headerName: "No",
          sortable: false,
          flex: 1,
          cellRenderer: (params) => {
            const value = params.value;
            if (value === "1" || value === "2" || value === "3") return value;
            if (value === "Grand Total") return <strong>{value}</strong>;
            return value;
          },
        },

        // Dynamically generated columns except "no" and "rating"
        ...Object.keys(
          filterDetailsData?.workordercategory === 2
            ? Object.fromEntries(
                Object.entries(data[0] || {}).filter(
                  ([key]) => key !== "requestorName" && key !== "designation"
                )
              )
            : (data[0] || {})
        )
          .filter((key) => {
            if (!key) return false;
            const k = key.trim().toLowerCase();
            return k !== "no" && k !== "rating";   // ⬅️ IMPORTANT — remove rating
          })
          .map((key) => {
            function formatHeaderName(key) {
              return String(key)
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (s) => s.toUpperCase())
                .trim();
            }

            // If nested object
            if (typeof data[0][key] === "object" && data[0][key] !== null) {
              return {
                headerName: key,
                children: Object.keys(data[0][key]).map((subKey) => {
                  const value = data[0][key][subKey];
                  const isDate = !isNaN(Date.parse(value));
                  const formattedValue = isDate
                    ? moment(value, "MM/DD/YYYY").format("DD/MM/YYYY")
                    : value;

                  return {
                    field: `${key}.${subKey}`,
                    headerName: subKey,
                    sortable: false,
                    width: 150,
                    flex: 5,
                    autoHeight: true,
                    valueGetter: () => formattedValue,
                  };
                }),
                headerClass: "center-align",
                cellClass: "wrap-text",
              };
            }

            // Normal column
            return {
              field: key,
              headerName: formatHeaderName(key),
              sortable: false,
              wrapHeaderText: true,
              headerClass: "center-align",
              cellClass: "wrap-text",
              autoHeight: true,
              flex: 5,
              width: 150,
              hide: hiddenFields.includes(key),
              cellRenderer: (params) => {
                const normalizedKey = key.trim().toLowerCase();

                // Format date
                if (normalizedKey === "scheduleddate" || normalizedKey === "agreeddate") {
                  return params.value
                    ? moment(params.value, [
                        "YYYY-MM-DD",
                        "MM/DD/YYYY",
                        "DD/MM/YYYY",
                        "x",
                      ]).format("DD/MM/YYYY")
                    : "-";
                }

                // Link conditions
                if (filterDetailsData?.options?.id === 2 && key === "workOrderNo") {
                  return (
                    <a
                      href="#"
                      style={{
                        textAlign: "right",
                        display: "inline-block",
                        width:
                          formatHeaderName(key) === "Number Of Workorders Count"
                            ? "40%"
                            : "80%",
                      }}
                      onClick={(event) => {
                        event.preventDefault();
                        handleNameClick(key, params.data);
                      }}
                    >
                      {params.value}
                    </a>
                  );
                }

                // Link for normal numeric columns
                if (
                  (key === "workOrderNo" &&
                    level === 3 &&
                    !(filterDetails?.Level === "HQ") &&
                    !(filterDetails?.workordercategory === 3) &&
                    !(filterDetailsData?.groupBy?.value === 6)) ||
                  (typeof params.value === "number" &&
                    params.value > 0 &&
                    !(filterDetails?.Level === "HQ") &&
                    !(filterDetails?.workordercategory === 3) &&
                    !(filterDetailsData?.groupBy?.value === 6))
                ) {
                  return (
                    <a
                      href="#"
                      style={{
                        textAlign: "right",
                        display: "inline-block",
                        width:
                          formatHeaderName(key) === "Number Of Workorders Count"
                            ? "40%"
                            : "80%",
                      }}
                      onClick={(event) => {
                        event.preventDefault();
                        handleNameClick(key, params.data);
                      }}
                    >
                      {params.value}
                    </a>
                  );
                }

                // Default content
                return (
                  <span
                    style={{
                      textAlign: typeof params.value === "number" ? "right" : "left",
                      display: "inline-block",
                      width: "80%",
                      paddingLeft: typeof params.value === "number" ? "0" : "8px",
                    }}
                  >
                    {params.value}
                  </span>
                );
              },
            };
          }),

       
        ((filterDetailsData?.options?.id === 2  && filterDetails?.workordercategory === 1) && {
          field: "rating",
          headerName: "Rating",
          width: 250,
          wrapHeaderText: false,
          sortable: false,
          cellRenderer: (params) => {
            const raw = params.value ?? params.data?.rating ?? 0;
            let rating = Number(raw);

            if (!Number.isFinite(rating)) rating = 0;
            rating = Math.max(0, Math.min(5, Math.floor(rating)));

            const maxStars = 5;

            // star icons
            const filledStars = Array.from({ length: rating }, (_, i) => (
              <StarIcon key={`filled-${i}`} sx={{ fontSize: 20, color: "#FFD700" }} />
            ));
            const emptyStars = Array.from({ length: maxStars - rating }, (_, i) => (
              <StarBorderIcon key={`empty-${i}`} sx={{ fontSize: 20, color: "#FFD700" }} />
            ));

            return (
              <div style={{ display: "inline-flex", alignItems: "center" }}>
                {filledStars}
                {emptyStars}
              </div>
            );
          },
        }),
      ]
    : [];


  const serviceTypeOptions = [
    { label: "All", value: "All" },
    { label: "BEMS", value: "BEMS" },
    { label: "FEMS", value: "FEMS" },
  ];

  const levelname = [
    { label: "Hospital", value: "Hospital" },
    { label: "HQ", value: "HQ" },
  ];

  const optionsname = [
    { label: "Summary", value: 1, id: 1 },
    { label: "Details", value: 2, id: 2 },
  ];

  const priorityTypeOption = [
    { label: "All", value: 3, id: null },
    { label: "Normal", value: 1, id: 1 },
    { label: "Critical", value: 2, id: 2 },
  ];
  const [optionslist, setOptionsList] = useState(optionsname[0]);
  const [levellist, setLevelList] = useState(levelname[0]);
  const [hospitalList, setHospitalList] = useState([]);
  const [hospitalListOptions, setHospitalListOptions] = useState([]);
  const [workOrder, setWorkOrder] = useState([]);
  const [workGroupOptions, setWorkGroupOptions] = useState([]);
  const [woType, setWOtype] = useState([]);
  const [detailsData, setDetailsData] = useState([]);
  const [errors, setErrors] = useState({});
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [gridApi, setGridApi] = useState(null);

  const handleNameClick = async (columnName, item) => {
    let updateLevel = level + 1;
    let additionalColumnDetails = item;
    // Set the new level and then make the API call
    setLevel(updateLevel);
    setHistory([...history, data]);
    setCanGoBack(true);
    setLoading(true);
    if (updateLevel === 2) {
      setWorkOrderStatus(columnName);
    }

    let filterDetailsDataValue = {
      facilityid: filterDetailsData?.facilityid || "",
      fromDate: filterDetailsData?.fromDate || "",
      groupBy: filterDetailsData?.groupBy?.value || "",
      hospitalName: filterDetailsData?.hospitalName || "",
      hospitalid: filterDetailsData?.hospitalid || "",
      priority: filterDetailsData?.priority || "",
      scheduleWorkorderReportLevelOneLists: filterDetailsData?.scheduleWorkorderReportLevelOneLists || [],
      serviceId: filterDetailsData?.serviceId || "",
      toDate: filterDetailsData?.toDate || "",
      workOrderType: filterDetailsData?.workOrderType || "",
      workordercategory: filterDetailsData?.workordercategory || "",
      options: filterDetailsData?.options?.value || ""
    }
    // Update filterDetailsData with new parameters
    const updatedFilterDetailsData = {
      ...filterDetailsDataValue,
      workOrderStatus: workOrderStatus,
      level: level + 1,
    };

    // Make the API call after setting the new level
    const getWorkOrderDetails = await fetchWorkOrderDetails(
      updatedFilterDetailsData,
      columnName,
      updateLevel,
      additionalColumnDetails
    );
  };

  const handleLevelFourClick = (newData) => {
    setLeveldata(newData);
  };


  const fetchWorkOrderDetails = async (
    filterDetailsData,
    columnName,
    updateLevel,
    additionalColumnDetails
  ) => {

    let getWorkOrderDetails;
    let apiFilterData;
    let formattedTypeValue = Array.isArray(filterDetailsData?.workOrderType) && filterDetailsData?.workOrderType.length > 0
      ? filterDetailsData.workOrderType.map((item) => item.id).includes(12)
        ? null // If "12" is included, set null
        : filterDetailsData.workOrderType.map((item) => item.id).join(",") // Else join the IDs
      : ""
    if (columnName !== null) {

      apiFilterData = {
        facilityid: filterDetailsData?.hospitalid,
        hospitalid: filterDetailsData?.hospitalid,
        hospitalName: filterDetailsData?.hospitalName,
        serviceId: filterDetailsData?.serviceId,
        workordercategory: filterDetailsData?.workordercategory === 3 ? null : filterDetailsData?.workordercategory,
        fromDate: filterDetailsData?.fromDate,
        toDate: filterDetailsData?.toDate,
        groupBy: filterDetailsData?.groupBy,
        workOrderType: formattedTypeValue,
        // workOrderType:filterDetailsData?.workOrderType  === 12 ? null :filterDetailsData?.workOrderType ,
        workOrderStatus: updateLevel === 2 ? columnName : workOrderStatus,
        priority: filterDetailsData?.priority === 3 ? null : filterDetailsData?.priority,
        options: filterDetailsData?.options || ""


      };
    } else {

      apiFilterData = {
        facilityid: filterDetailsData?.hospitalid,
        hospitalid: filterDetailsData?.hospitalid,
        hospitalName: filterDetailsData?.hospitalName,
        serviceId: filterDetailsData?.serviceId,
        workordercategory: filterDetailsData?.workordercategory === 12 ? null : filterDetailsData?.workordercategory,
        fromDate: filterDetailsData?.fromDate,
        toDate: filterDetailsData?.toDate,
        groupBy: filterDetailsData?.groupBy,
        workOrderType: formattedTypeValue,
        options: filterDetailsData?.options || ""

        // workOrderType: filterDetailsData?.workOrderType  === 3 ? null :filterDetailsData?.workOrderType ,
      };
    }

    // if(updateLevel === 4 && filterDetailsData?.options === 2){
    //   // apiFilterData = {
    //   //   ...apiFilterData,
    //   //   facilityid: filterDetailsData?.hospitalid,
    //   //   workOrderId: additionalColumnDetails?.workOrderId,
    //   //   service:additionalColumnDetails?.service || "",
    //   // };
    //   // setServiceLevel(apiFilterData)

    //   // const workOrderStatus = "";
    //   // setLastApiParams({
    //   //   apiFilterData,
    //   //   workOrderStatus,
    //   //   updateLevel,
    //   //   additionalColumnDetails,
    //   // }); // Store the parameters of the last API call
    //   // console.log("hiii");

    //   console.log(additionalColumnDetails,"additionalColumnDetails");

    //   handleLevelFourClick(additionalColumnDetails)
    // }

    if (updateLevel === 3) {
      if (apiFilterData.groupBy === 1) {
        apiFilterData = {
          ...apiFilterData,
          typecodeId: additionalColumnDetails.typecodeId,
        };
      }
      else if (apiFilterData.groupBy === 2) {
        let AssetStartAge = "";
        let AssetEndAge = "";

        switch (additionalColumnDetails.name) {
          case "0-5":
            AssetStartAge = 1;
            AssetEndAge = 5;
            break;
          case "5-10":
            AssetStartAge = 5;
            AssetEndAge = 10;
            break;
          case "10-15":
            AssetStartAge = 10;
            AssetEndAge = 15;
            break;
          case "15 And above":
            AssetStartAge = 15;
            AssetEndAge = 100;
            break;
          default:
            break;
        }
        apiFilterData = {
          ...apiFilterData,
          count: additionalColumnDetails.count,
          AssetStartAge,
          AssetEndAge,
        };
      }
      else if (apiFilterData.groupBy === 3) {
        apiFilterData = {
          ...apiFilterData,
          departmentId: additionalColumnDetails.departmentId,
        };
      } else if (apiFilterData.groupBy === 4) {
        apiFilterData = {
          ...apiFilterData,
          workGroupId: additionalColumnDetails.workGroupId,
        };
      }
      setAdtionalcolumnDetailsThirdLevel(additionalColumnDetails);
    }
console.log(adtionalcolumnDetailsThirdLevel,"adf")
    if (updateLevel === 4) {

      apiFilterData = {
        ...apiFilterData,
        facilityid: filterDetailsData?.hospitalid,
        workOrderId: additionalColumnDetails?.workOrderId,
        service: additionalColumnDetails?.service || "",
        category: additionalColumnDetails?.category
      };
      setServiceLevel(apiFilterData)

      const workOrderStatus = "";
      setLastApiParams({
        apiFilterData,
        workOrderStatus,
        updateLevel,
        additionalColumnDetails,
      }); // Store the parameters of the last API call
    }

    if (updateLevel !== 4) {
      setLastApiParams({
        apiFilterData,
        workOrderStatus,
        updateLevel,
        additionalColumnDetails,
      }); // Store the parameters of the last API call
    }

    setHistoryApiFilterData(apiFilterData); // Store the apiFilterData of the last API call
    setLevel(updateLevel);

    try {
      getWorkOrderDetails = await AssetRepository.getWorkorderReport(
        apiFilterData,
        updateLevel
      );

      // Process the fetched details
      if (getWorkOrderDetails) {
        let apiFilter;
        setLoading(false);
        if (filterDetailsData.workordercategory === 2) {
          if (updateLevel === 1) {
            apiFilter = getWorkOrderDetails.scheduleWorkorderReportLevelOneList;
          } else if (updateLevel === 2) {
            if (getWorkOrderDetails.groupBy === 1) {
              apiFilter =
                getWorkOrderDetails.scheduleWorkorderReportAssetTypeLevelTwoLists;
            }
            if (getWorkOrderDetails.groupBy === 2) {
              apiFilter =
                getWorkOrderDetails.workorderReportAssetAgeLevelTwoLists;
            }
            if (getWorkOrderDetails.groupBy === 3) {
              apiFilter =
                getWorkOrderDetails.workorderReportDepartmentLevelTwoLists;
            }
            if (getWorkOrderDetails.groupBy === 4) {
              apiFilter =
                getWorkOrderDetails.scheduleWorkorderReportWorkGroupLevelTwoLists;
            }
          } else if (updateLevel === 3) {
            if (getWorkOrderDetails.groupBy === 1) {
              apiFilter =
                getWorkOrderDetails.scheduleWorkorderReportAssetTypeLevelThreeLists;
            }
            if (getWorkOrderDetails.groupBy === 2) {
              apiFilter =
                getWorkOrderDetails.woLevelThreeLists;
            }
            if (getWorkOrderDetails.groupBy === 3) {
              apiFilter =
                getWorkOrderDetails.woLevelThreeLists;
            }
            if (getWorkOrderDetails.groupBy === 4) {
              apiFilter =
                getWorkOrderDetails.unScheduleWorkorderReportWorkGroupLevelThreeLists;
            }
          } else if (updateLevel === 4) {
            handleLevelFourClick(getWorkOrderDetails);
          }
        } else if (filterDetailsData.workordercategory === 1) {
          if (updateLevel === 1) {
            apiFilter =
              getWorkOrderDetails.UnScheduleWorkorderReportLevelOneLists;
          } else if (updateLevel === 2) {
            if (getWorkOrderDetails.groupBy === 1) {
              apiFilter =
                getWorkOrderDetails.unScheduleWorkorderReportAssetTypeLevelTwoLists;
            }
            if (getWorkOrderDetails.groupBy === 2) {
              apiFilter =
                getWorkOrderDetails.workorderReportAssetAgeLevelTwoLists;
            }

            if (getWorkOrderDetails.groupBy === 3) {
              apiFilter =
                getWorkOrderDetails.workorderReportDepartmentLevelTwoLists;
            }
            if (getWorkOrderDetails.groupBy === 4) {
              apiFilter =
                getWorkOrderDetails.unScheduleWorkorderReportWorkGroupLevelTwoLists;
            }
          } else if (updateLevel === 3) {
            if (getWorkOrderDetails.groupBy === 1) {
              apiFilter =
                getWorkOrderDetails.unScheduleWorkorderReportAssetTypeLevelThreeLists;
            }
            if (getWorkOrderDetails.groupBy === 2) {
              apiFilter =
                getWorkOrderDetails.woLevelThreeLists;
            }
            if (getWorkOrderDetails.groupBy === 3) {
              apiFilter =
                getWorkOrderDetails.woLevelThreeLists;
            }
            if (getWorkOrderDetails.groupBy === 4) {
              apiFilter =
                getWorkOrderDetails.unScheduleWorkorderReportWorkGroupLevelThreeLists;
            }
          } else if (updateLevel === 4) {

            handleLevelFourClick(getWorkOrderDetails);
          }
        } else {

          if (updateLevel === 1) {
            apiFilter =
              getWorkOrderDetails.UnScheduleWorkorderReportLevelOneLists;
          } else if (updateLevel === 2) {
            if (getWorkOrderDetails.groupBy === 1) {
              apiFilter =
                getWorkOrderDetails.unScheduleWorkorderReportAssetTypeLevelTwoLists;
            }
            if (getWorkOrderDetails.groupBy === 2) {
              apiFilter =
                getWorkOrderDetails.workorderReportAssetAgeLevelTwoLists;
            }

            if (getWorkOrderDetails.groupBy === 3) {
              apiFilter =
                getWorkOrderDetails.workorderReportDepartmentLevelTwoLists;
            }
            if (getWorkOrderDetails.groupBy === 4) {
              apiFilter =
                getWorkOrderDetails.unScheduleWorkorderReportWorkGroupLevelTwoLists;
            }
          } else if (updateLevel === 3) {
            if (getWorkOrderDetails.groupBy === 1) {
              apiFilter =
                getWorkOrderDetails.unScheduleWorkorderReportAssetTypeLevelThreeLists;
            }
            if (getWorkOrderDetails.groupBy === 2) {
              apiFilter =
                getWorkOrderDetails.woLevelThreeLists;
            }
            if (getWorkOrderDetails.groupBy === 3) {
              apiFilter =
                getWorkOrderDetails.woLevelThreeLists;
            }
            if (getWorkOrderDetails.groupBy === 4) {
              apiFilter =
                getWorkOrderDetails.unScheduleWorkorderReportWorkGroupLevelThreeLists;
            }
          } else if (updateLevel === 4) {

            handleLevelFourClick(getWorkOrderDetails);
          }
        }
        // setLeveldata(levelFourData);
        if (apiFilter && updateLevel !== 4) {
          const updatedData = apiFilter?.map((item, index) => ({
            ...item,
            no: index + 1,
          }));
          if (updateLevel === 1) {
            setData(updatedData[0]);
          } else {
            setData(updatedData);
          }
        }
      }
    }
    catch (e) {
      console.log("Error getting Level 4 data  ", e);
    }
  };


  const fetchOptions = async () => {
    try {
      setErrors({});
      const workgroupdetails =
        await commonMasterRepository.getWorkGroupDetails();

      if (!workgroupdetails?.data) return;
      setWorkGroupOptions(workgroupdetails.status ? [] : workgroupdetails);

      const maintanenceyear = await commonMasterRepository.getMaintanenceYear();
      if (maintanenceyear) {
        setWOtype(
          maintanenceyear?.filter(
            (item) => item?.label <= new Date().getFullYear()
          )
        );
      }

    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchOptions();

  }, [servicelevel]);

  useEffect(() => {
    const numericColumns = ["Size"]; // Add other numeric column names here
    const totalRow = {};
    workGroupCodeDetails();
    handleHospitalList();
    numericColumns.forEach((col) => {
      totalRow[col] = data?.reduce((sum, row) => sum + (row[col] || 0), 0);
    });
    setHospitalList({ label: facilityName, id: facilityId });
    setFilterDetailsData((prev) => ({
      ...prev,
      hospitalName: facilityName,
      hospitalid: facilityId,
      Userid: userid,
      options: optionsname[0]
    }));
  }, []);

  const handleHospitalList = async () => {
    try {
      const response = await UserRepository.hospitalNameList();
      const listofhospitals = response.data.map((item) => ({
        label: item.facilityName,
        value: item.facilityName,
        id: item.facilityId,
      }))
      if (listofhospitals?.length > 0) {

        setHospitalListOptions(listofhospitals);
      }
      else {
        setHospitalListOptions([])
      }
    } catch (e) {
      console.log(e);
    }
  };

  const workGroupCodeDetails = async () => {
    try {
      const response = await AssetRepository.filterDetails();

      // Generic transformation function for common structures
      const transformData = (data, labelKey = "workordercategory") =>
        data?.map((item) => ({
          label: item[labelKey],
          value: item.id,
        }));

      if (response.femworkordercategory) {
        const groupData = response.femworkordercategory.filter(
          (item) => item.id >= 0 && item.id <= 2
        );
        const transformedData = transformData(groupData);

        setWorkOrder([{ label: "All", value: 3, id: null }, ...transformedData]);

      } else {
        // If no categories are returned, still include "All"
        setWorkOrder([{ label: "All", value: 3, id: null }]);

      }

      if (response.femwoanalysisgroupby) {
        const transformedData = response.femwoanalysisgroupby.map((item) => ({
          label: item.groupby,
          value: item.id,
        }));

        // Add the "All" option at the start of the array
        const updatedData = [{ label: "All", value: 6 }, ...transformedData];
        setWorkGroupOptions(updatedData);

      }

    } catch (error) {
      console.error("Failed to fetch asset data:", error);
    }
  };

  const getWOTypes = async () => {
    if (!(filterDetailsData?.workordercategory === 3) && (filterDetailsData?.workordercategory)) {

      try {
        const categoryId = filterDetailsData?.workordercategory === 3 ? 0 : filterDetailsData?.workordercategory;
        const response = await AssetRepository.fetchWOTypes(categoryId || "");
        const formattedResponse = response?.map((item) => (
          {
            key: `option${item?.id}`,
            label: item?.workordertype,
            isvisible: item?.isvisible,
            id: item?.id,
            value: item?.id,
            femworkordercategoryId: item?.femworkordercategoryId
          })).filter(type => (type?.femworkordercategoryId === 1 && (type?.id === 1 || type?.id === 2)) || type?.femworkordercategoryId === 3 || type?.femworkordercategoryId === 2)
        setWOtype([{ label: "All", id: 12, value: 12 }, ...(formattedResponse || [])]);
      } catch (error) {
        console.error("Error fetching WO Types:", error);
      }

    } else {
      const response = await AssetRepository.filterDetails();
      const formattedResponse = response?.femworkordertype?.map((item) => (
        {
          key: `option${item?.id}`,
          label: item?.workordertype,
          isvisible: item?.isvisible,
          id: item?.id,
          value: item?.id,
          femworkordercategoryId: item?.femworkordercategoryId
        })).filter(type => (type?.femworkordercategoryId === 1 && (type?.id === 1 || type?.id === 2)) || type?.femworkordercategoryId === 3 || type?.femworkordercategoryId === 2)
      setWOtype([{ label: "All", id: 12, value: 12 }, ...(formattedResponse || [])]);
    }
  };

  useEffect(() => {
    getWOTypes();
  }, [filterDetailsData?.workordercategory])

  const validateFieldSelectFields = (
    value,
    fieldName,
    isAllOptionValid = false,
    otherFieldValue = null,
    isDateField = false
  ) => {

    const parseDate = (dateStr) => {
      const [day, month, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    const isValidDate = (dateStr) => {
      const date = parseDate(dateStr);
      return !isNaN(date.getTime());
    };

    if ((!value || (Array.isArray(value) && value.length === 0)) && !isAllOptionValid) {
      return `Please Select ${fieldName}`;
    }

    if (fieldName === "Priority" && value === null && !isAllOptionValid) {
      return `Please Select ${fieldName}`;
    }

    if (fieldName === "Work Order" && value === null && !isAllOptionValid) {
      return `Please Select ${fieldName}`;
    }

    if (isDateField) {
      if (!isValidDate(value)) {
        return `Invalid ${fieldName}`;
      }

      const currentDate = parseDate(value);
      const comparisonDate = otherFieldValue && isValidDate(otherFieldValue) ? parseDate(otherFieldValue) : null;

      if (comparisonDate) {
        if (fieldName === "To Date" && currentDate < comparisonDate) {
          return "To Date cannot be earlier than From Date";
        }
      }
    }

    return ""; // No error
  };


  const handleGetResults = async () => {
    try {
      const hospitalCodeError = filterDetailsData?.hospitalName
        ? ""
        : validateFieldSelectFields(filterDetailsData?.hospitalName, "Hospital Name");


      const serviceTypeError = validateFieldSelectFields(
        filterDetailsData?.serviceId,
        "Service Type"
      );
      const workOrderError = validateFieldSelectFields(
        filterDetailsData?.workordercategory,
        "Work Order",
        false // Set to true if "All" is valid for Priority
      );
      const workGroupError = validateFieldSelectFields(
        filterDetailsData?.groupBy?.value,
        "Group By",
        false
      );
      const woTypeError = validateFieldSelectFields(
        filterDetailsData?.workOrderType,
        "WO Type",
        false

      );
      // From Date and To Date validation
      let fromDateError = validateFieldSelectFields(
        filterDetailsData?.fromDate,
        "From Date"
      );
      let toDateError = validateFieldSelectFields(
        filterDetailsData?.toDate,
        "To Date"
      );

      // Ensure From Date is not greater than To Date
      if (
        filterDetailsData?.fromDate &&
        filterDetailsData?.toDate &&
        new Date(filterDetailsData.fromDate) > new Date(filterDetailsData.toDate)
      ) {

        toDateError = "To Date should not be less than From Date";
      }

      const priorityError = validateFieldSelectFields(
        filterDetailsData?.priority,
        "Priority"
      );

      if (
        !hospitalCodeError &&
        !serviceTypeError &&
        !workOrderError &&
        !workGroupError &&
        !woTypeError &&
        !fromDateError &&
        !toDateError &&
        !priorityError
      ) {
        setErrors({});

        setLoading(true);
        // Update table values with validated filter data
        setcommonTableLabel(commonTableDetails);
        // Update Redux store
        dispatch(updateFilterDetails(filterDetailsData));
        let getWorkOrderDetails;
        let apiFilterData;
        let formattedTypeValue = Array.isArray(filterDetailsData?.workOrderType) && filterDetailsData?.workOrderType.length > 0
          ? filterDetailsData.workOrderType.map((item) => item.id).includes(12)
            ? null // If "12" is included, set null
            : filterDetailsData.workOrderType.map((item) => item.id).join(",") // Else join the IDs
          : ""
        const getcolumnName = null;
        const getupdateLevel = 1;
        apiFilterData = {
          facilityid: filterDetailsData?.hospitalid,
          hospitalid: filterDetailsData?.hospitalid,
          serviceId: "",
          Userid: filterDetailsData?.Userid || "",
          workordercategory: filterDetailsData?.workordercategory === 3 ? null : filterDetailsData?.workordercategory,
          fromDate: filterDetailsData?.fromDate,
          toDate: filterDetailsData?.toDate,
          groupBy: filterDetailsData?.groupBy?.value,
          workOrderType: formattedTypeValue,
          // workOrderType:filterDetailsData?.workOrderType?.id  === 3 ? null :filterDetailsData?.workOrderType?.id ,
          hospitalid: filterDetailsData?.id,
          priority: filterDetailsData?.priority === 3 ? null : filterDetailsData?.priority,
          options: filterDetailsData?.options?.value || ""

        };
        if (level === 2) {
          apiFilterData = {
            facilityid: filterDetailsData?.hospitalid,
            hospitalid: filterDetailsData?.hospitalid,
            serviceId: "",
            Userid: filterDetailsData?.Userid || "",
            workordercategory: filterDetailsData?.workordercategory === 3 ? null : filterDetailsData?.workordercategory,
            fromDate: filterDetailsData?.fromDate,
            toDate: filterDetailsData?.toDate,
            groupBy: filterDetailsData?.groupBy?.value,
            workOrderType: formattedTypeValue,
            // workOrderType: filterDetailsData?.workOrderType?.id  === 3 ? null :filterDetailsData?.workOrderType?.id ,
            workOrderStatus: workOrderStatus,
            options: filterDetailsData?.options?.value || ""

          };
        }
        setLastApiParams({
          apiFilterData,
          columnName: getcolumnName,
          updateLevel: getupdateLevel,
          additionalColumnDetails: adtionalcolumnDetailsThirdLevel,
        }); // Store the parameters of the last API call

        let API_Payoad = {
          facilityid: filterDetailsData?.facilityid || "",
          fromDate: filterDetailsData?.fromDate || "",
          groupBy: filterDetailsData?.groupBy?.value || "",
          hospitalName: filterDetailsData?.hospitalName || "",
          hospitalid: filterDetailsData?.hospitalid || "",
          priority: filterDetailsData?.priority || "",
          Userid: filterDetailsData?.Userid || "",
          scheduleWorkorderReportLevelOneLists: filterDetailsData?.scheduleWorkorderReportLevelOneLists || [],
          serviceId: filterDetailsData?.serviceId || "",
          toDate: filterDetailsData?.toDate || "",
          workOrderType: formattedTypeValue,
          workordercategory: filterDetailsData?.workordercategory || "",
          Level: filterDetailsData?.Level || "",
          options: filterDetailsData?.options?.value || ""
        }

        try {
          getWorkOrderDetails = await AssetRepository.getWorkorderReport(
            API_Payoad,
            1
          );
        }
        catch (e) {
          console.log("Error getting level 4 data", e);
        }

        if (getWorkOrderDetails) {
          setLoading(false);
          let apiFilter;
          if (filterDetailsData?.options?.id === 2) {
            apiFilter = getWorkOrderDetails?.workorderReportDetailsListVMs || []
          } else {
            if (filterDetailsData.workordercategory === 2 && getWorkOrderDetails?.groupBy) {
              apiFilter = getWorkOrderDetails?.scheduleWorkorderReportLevelOneLists || [];
            } else if (filterDetailsData.workordercategory === 1 && getWorkOrderDetails?.groupBy) {
              apiFilter = getWorkOrderDetails?.unScheduleWorkorderReportLevelOneLists || [];
            } else {
              apiFilter = getWorkOrderDetails?.workorderReportGroupByAllLists || [];
            }
          }

          if (apiFilter && apiFilter.length > 0) {
            // Filter out undefined values
            const filteredApiFilter = apiFilter.filter(
              (item) => item !== undefined
            );

            // Proceed only if there are valid items
            if (filteredApiFilter.length > 0) {

              const updatedData = filteredApiFilter.map((item, index) => ({
                ...item,
                no: index + 1,
              }));
              if (filterDetailsData?.options?.id === 2) {
                setLevel(3)
              } else {
                setLevel(1)
              }
              // setLevel(filterDetailsData?.options?.id === 2 ? 2 : 1);

              setData(updatedData);
              setDetailsData(updatedData);
            } else {
              // Handle case where filtered array is empty
              setData([]);
              setLevel(1);
            }
          } else {
            // Handle case where apiFilter is empty or undefined
            setData([]);
            setLevel(1);
          }
        }
      } else {
        setErrors({
          hospitalName: hospitalCodeError,
          serviceId: serviceTypeError,
          workordercategory: workOrderError,
          groupBy: workGroupError,
          workOrderType: woTypeError,
          fromDate: fromDateError,
          toDate: toDateError,
          priority: priorityError,

        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const currentHandleGridRefresh = () => {
    gridApi.setFilterModel(null);
    if (lastApiParams) {
      const {
        apiFilterData,

        updateLevel,
        additionalColumnDetails,
      } = lastApiParams;
      const columnName = workOrderStatus;

      fetchWorkOrderDetails(
        apiFilterData,
        columnName,
        updateLevel,
        additionalColumnDetails
      );
    }
  };

  const getLabelForWorkOrder = (workOrderValue) => {
    const matchedWorkOrder = workOrder.find(
      (order) => order.value === workOrderValue
    );
    return matchedWorkOrder ? matchedWorkOrder.label.toUpperCase() : "";
  };

  const handleBackClick = () => {
    if (level > 1) {
      setData(history[history.length - 1]);
      setHistory(history.slice(0, -1));
      setLevel(level - 1);
      setCanGoBack(level > 2);
      let apiFilterData = historyApiFilterData;
      setLastApiParams({
        apiFilterData,
        columnName: workOrderStatus,
        updateLevel: level - 1,
        additionalColumnDetails: adtionalcolumnDetailsThirdLevel,
      }); // Store the parameters of the last API call
    }
  };

  const filename = filterDetailsData?.workordercategory
    ? `${getLabelForWorkOrder(
      filterDetailsData?.workordercategory
    )} `
    : "";

  // Find the matching work order type
  const matchingWoType = woType?.find(
    (woTypes) => {
      // if (filterDetailsData?.workOrderType === 3) return null;
      return woTypes.value === filterDetailsData?.workOrderType?.label;
    }
  );

  let commonTableDetails = {
    Hospital:filterDetailsData?.Level == "HQ" ? "All" : filterDetailsData?.hospitalName ? filterDetailsData?.hospitalName : null,
    Service: filterDetailsData?.serviceId ? filterDetailsData?.serviceId : null,
    FromDate: filterDetailsData?.fromDate ? filterDetailsData?.fromDate : null,
    ToDate: filterDetailsData?.toDate ? filterDetailsData?.toDate : null,
    WorkType: matchingWoType ? matchingWoType.label : "",
    priority: filterDetailsData?.priority ? filterDetailsData?.priority : null,
    title: filename,
    options: filterDetailsData?.options?.label || "",
  };


  const formatHeader = (header) => {
    // Add spaces between camelCase words and capitalize the first letter of each word
    return header.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^[a-z]/, char => char.toUpperCase());
  };

  const exportPDF = async () => {
    const pdf = new jsPDF();
    const refData = data || [];
    pdf.setFontSize(7);

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const leftMargin = 10;
    const adjustedPdfWidth = pdfWidth - leftMargin - margin;
    const topMargin = 40;
    const bottomMargin = 20; // Prevent overwriting the footer

    if (!Array.isArray(refData)) {
      console.error("refData is not an array or is undefined");
      return;
    }

    // Flatten nested data
    const flattenData = (refData) => {
      return refData.map((row) => {
        const flatRow = {};
        Object.keys(row).forEach((key) => {
          if (typeof row[key] === 'object' && !Array.isArray(row[key])) {
            Object.keys(row[key]).forEach((subKey) => {
              flatRow[`${key} - ${subKey}`] = row[key][subKey];
            });
          } else {
            flatRow[key] = row[key];
          }
        });
        return flatRow;
      });
    };

    const flattenedData = flattenData(refData);

    if (flattenedData.length === 0) {
      console.error("No data available to export");
      return;
    }

    // Exclude hidden fields and format headers
    const headers = Object.keys(flattenedData[0]).filter((header) => !hiddenFields.includes(header));
    const modifiedHeaders = ["No", ...headers.map((header) => formatHeader(header))];

    // Remove duplicates from the modifiedHeaders array
    const uniqueHeaders = modifiedHeaders.filter((header, index, self) => self.indexOf(header) === index);



    // Calculate dynamic column widths
    const calculateColumnWidths = (headers, data, totalWidth) => {
      const maxLengths = headers.map((header) => {
        const maxDataLength = Math.max(
          ...data.map((row) => (row[header] ? String(row[header]).length : 0))
        );
        return Math.max(header.length, maxDataLength);
      });

      const totalLength = maxLengths.reduce((sum, len) => sum + len, 0);
      return maxLengths.map((len) => (len / totalLength) * totalWidth);
    };

    const columnWidths = calculateColumnWidths(headers, flattenedData, adjustedPdfWidth);

    // Format data rows
    const rows = flattenedData.map((row, index) => {
      const filteredRow = headers.map((header) => {
        let cell = row[header];
        // Format date strings
        if (typeof cell === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(cell)) {
          cell = moment(cell).format('DD/MM/YYYY');
        }
        return cell;
      });

      return [
        { content: index + 1, styles: { halign: 'center', fontSize: 7 } },
        ...filteredRow.map((cell) => ({
          content: cell,
          styles: {
            halign: typeof cell === 'number' || !isNaN(cell) ? 'right' : 'center',
            fontSize: 7,
          },
        })),
      ];
    });

    // Split primary and secondary headers
    const primaryHeaders = [];
    const secondaryHeaders = [];
    let hasSecondaryHeaders = false;

    uniqueHeaders.forEach((header) => {
      const parts = header.split(" - ");
      if (parts.length > 1) {
        if (!primaryHeaders.includes(parts[0])) {
          primaryHeaders.push(parts[0]);
          secondaryHeaders.push([]);
        }
        const parentIndex = primaryHeaders.indexOf(parts[0]);
        secondaryHeaders[parentIndex].push(parts[1]);
        hasSecondaryHeaders = true;
      } else {
        primaryHeaders.push(header);
        secondaryHeaders.push([]);
      }
    });

    const tableHeaders = hasSecondaryHeaders
      ? [
        primaryHeaders.map((header) => ({
          content: header,
          rowSpan: header.includes(' ') ? 2 : 1,
          styles: { halign: 'center', fontSize: 7 },
        })),
        secondaryHeaders.flat().map((subHeader) => ({
          content: subHeader || '',
          styles: { halign: 'center', fontSize: 7 },
        })),
      ]
      :
      [
        primaryHeaders.map((header) => ({
          content: header,
          styles: { halign: 'center', fontSize: 7 },
        })),
      ];

    // Draw Header
    const drawHeader = (pdf, pageNumber) => {
      try {
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(7);
        pdf.text("WORK ORDER ANALYSIS SUMMARY REPORT", 105, 20, { align: "center" });
        pdf.setFont("helvetica", "normal");
        if (reportslogo) {
          pdf.addImage(reportslogo, "PNG", pdfWidth - 47, 10, 30, 18);
        }
        pdf.setLineWidth(0.5);
        pdf.setDrawColor(0);
        const headerBottomY = 33;
        pdf.line(leftMargin, headerBottomY, pdfWidth - margin, headerBottomY);
      } catch (error) {
        console.error('Error in drawHeader:', error);
      }
    };

    if (level === 4) {

      drawHeader(pdf, 1);

      // Declare and initialize currentY
      let currentY = topMargin;


      const tableData = [
        // First row: Hospital, Service, From Date, To Date
        [
          {
            content: `Hospital:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245], // Light gray background
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200], // Light gray border
              lineWidth: 0.5,
            },
          },
          {
            content: `${filterDetailsData?.Level == "HQ" ? "All" : commonTableLabel?.Hospital || ""}`, // Hospital value
            styles: {
              halign: "left",
              fillColor: [255, 255, 255], // White background
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200], // Light gray border
              lineWidth: 0.5,
            },
          },
          {
            content: `Service:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245],
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `${commonTableLabel?.Service || ""}`, // Service value
            styles: {
              halign: "left",
              fillColor: [255, 255, 255],
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `From Date:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245],
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `${commonTableLabel?.FromDate || ""}`,
            styles: {
              halign: "left",
              fillColor: [255, 255, 255],
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `To Date:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245],
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `${commonTableLabel?.ToDate || ""}`, // To Date value
            styles: {
              halign: "left",
              fillColor: [255, 255, 255],
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
        ],
        // Second row: Work Type
        [
          {
            content: `Work Type:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245],
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `${filterDetailsData?.workOrderType?.some((item) => item.label === "All")
              ? "All" // If any label is "All", show only "All"
              : filterDetailsData?.workOrderType?.map((item) => item.label).join(", ") || "" // Otherwise, show comma-separated labels
              }`,
            colSpan: 7, // Span across remaining columns
            styles: {
              halign: "left",
              fillColor: [255, 255, 255],
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
        ],
        //...rows, // Append the data rows below the title
      ];


      // Render the table
      pdf.autoTable({
        body: tableData,
        // startY: currentY,
        theme: "striped",
        styles: {
          fontSize: 7,
          lineColor: [192, 192, 192],
          lineWidth: 0.2,
          cellPadding: 2,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          overflow: "linebreak",
        },
        headStyles: { fillColor: "#009999", textColor: "white", fontStyle: "bold" },
        margin: { left: leftMargin, top: topMargin, bottom: bottomMargin },
        didDrawPage: function (data) {
          drawHeader(pdf, data.pageNumber);
        },
        showHead: "everyPage", // Only headers repeat (not title rows)
      });

      // Update currentY after the table
      currentY = pdf.autoTable.previous.finalY + 10;


      // Process the remaining sections
      const sections = getLevel4Data; // Assuming this provides the array of section data

      sections.forEach((section, index) => {
        // Check if a new page is needed before rendering a section
        if (index > 0 && currentY + 10 > pdfHeight - bottomMargin) {
          pdf.addPage();
          drawHeader(pdf, pdf.internal.getCurrentPageInfo().pageNumber);
          currentY = topMargin;
        }

        // Prepare table headers and rows
        const headers = section.data[0] ? Object.keys(section.data[0]) : [];

        const rows = section.data.map(row => Object.values(row));


        // Create a single table body with a title row at the top
        const tableData = [
          [
            {
              content: section.title, // Section title
              colSpan: headers.length, // Span the title across all columns
              styles: {
                halign: "center", // Center-align the title
                fillColor: "#009999",

                textColor: "white",
                fontStyle: "bold",
                fontSize: 7,
                cellPadding: 4,
              },
            },
          ],
          ...rows, // Append the data rows below the title
        ];

        // Render the table
        pdf.autoTable({
          body: tableData,
          startY: currentY,
          theme: "striped",
          styles: {
            fontSize: 7,
            lineColor: [192, 192, 192],
            lineWidth: 0.5,
            cellPadding: 2,
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            overflow: "linebreak",
            margin: { left: leftMargin },
            tableWidth: adjustedPdfWidth,
            columnWidth: (index) => columnWidths[index],

          },
          headStyles: { fillColor: "#009999", textColor: "white", fontStyle: "bold" },
          margin: { left: leftMargin, top: topMargin, bottom: bottomMargin },
          columnStyles: headers.reduce((styles, _, colIndex) => {
            styles[colIndex] = { cellWidth: "auto", halign: "left" }; // Adjust all columns to auto width
            return styles;
          }, {}),
          didDrawPage: function (data) {
            drawHeader(pdf, data.pageNumber);
          },
          showHead: "everyPage", // Only headers repeat (not title rows)
        });

        // Update currentY after the table
        currentY = pdf.autoTable.previous.finalY + 10;
      });

      // Add footer to all pages
      const totalPages = pdf.internal.getNumberOfPages();
      const dateStr = new Date().toLocaleString();

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(7);
        const pageStr = `Date & Time: ${dateStr}`;
        const pageNumStr = `Page ${i} of ${totalPages}`;
        pdf.text(pageStr, margin, pdfHeight - 10);
        pdf.text(pageNumStr, pdfWidth - pdf.getTextWidth(pageNumStr) - margin, pdfHeight - 10);
        const footerY = pdf.internal.pageSize.height - bottomMargin;
        pdf.setLineWidth(0.5);
        pdf.setDrawColor(0);
        pdf.line(leftMargin, footerY, pdfWidth - margin, footerY);
      }
    }
    else {
      drawHeader(pdf, 1);


      const tableData = [
        // First row: Hospital, Service, From Date, To Date
        [
          {
            content: `Hospital:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245], // Light gray background
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200], // Light gray border
              lineWidth: 0.5,
            },
          },
          {
            content: `${filterDetailsData?.Level == "HQ" ? "All" : commonTableLabel?.Hospital || ""}`, // Hospital value
            styles: {
              halign: "left",
              fillColor: [255, 255, 255], // White background
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200], // Light gray border
              lineWidth: 0.5,
            },
          },
          {
            content: `Service:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245],
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `${commonTableLabel?.Service || ""}`, // Service value
            styles: {
              halign: "left",
              fillColor: [255, 255, 255],
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `From Date:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245],
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `${commonTableLabel?.FromDate || ""}`,
            styles: {
              halign: "left",
              fillColor: [255, 255, 255],
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `To Date:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245],
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `${commonTableLabel?.ToDate || ""}`, // To Date value
            styles: {
              halign: "left",
              fillColor: [255, 255, 255],
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
        ],
        // Second row: Work Type
        [
          {
            content: `Work Type:`,
            styles: {
              halign: "left",
              fillColor: [245, 245, 245],
              textColor: "black",
              fontStyle: "bold",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
          {
            content: `${filterDetailsData?.workOrderType?.some((item) => item.label === "All")
              ? "All" // If any label is "All", show only "All"
              : filterDetailsData?.workOrderType?.map((item) => item.label).join(", ") || "" // Otherwise, show comma-separated labels
              }`,
            colSpan: 7, // Span across remaining columns
            styles: {
              halign: "left",
              fillColor: [255, 255, 255],
              textColor: "black",
              fontStyle: "normal",
              fontSize: 7,
              cellPadding: 2,
              lineColor: [200, 200, 200],
              lineWidth: 0.5,
            },
          },
        ],
        // ...rows, // Append the data rows below the title
      ];



      // Render the table
      pdf.autoTable({
        body: tableData,
        theme: "plain",
        styles: {
          fontSize: 7,
          lineColor: [192, 192, 192],
          lineWidth: 0.5,
          cellPadding: 2,
          overflow: "linebreak",
        },
        margin: { left: leftMargin, top: topMargin, bottom: bottomMargin },

        didDrawPage: function (data) {
          drawHeader(pdf, data.pageNumber);
        },
      });


      pdf.autoTable({
        head: tableHeaders,
        body: rows,
        // startY: topMargin + imgHeight + 1, // Reduced space between the table image and the table content
        theme: "striped",
        styles: {
          fontSize: 7,
          lineColor: [192, 192, 192],
          lineWidth: 0.5,
          cellPadding: 2,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          overflow: 'linebreak', // Ensure text wraps correctly within cell
        },
        headStyles: { fillColor: '#D3D3D3', textColor: "#000000" },
        margin: { left: leftMargin, top: topMargin, bottom: bottomMargin },
        //  columnStyles: Array(columnCount).fill({ cellWidth: columnWidth }),
        didDrawPage: function (refData) {
          // Ensure header is drawn on every page
          drawHeader(pdf, refData.pageNumber);
        },
      });


      const totalPages = pdf.internal.getNumberOfPages();
      const dateStr = new Date().toLocaleString();

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(7);
        const pageStr = `Date & Time: ${dateStr}`;
        const pageNumStr = `Page ${i} of ${totalPages}`;
        pdf.text(pageStr, margin, pdfHeight - 10);
        pdf.text(pageNumStr, pdfWidth - pdf.getTextWidth(pageNumStr) - margin, pdfHeight - 10);
        const footerY = pdf.internal.pageSize.height - bottomMargin;
        pdf.setLineWidth(0.5);
        pdf.setDrawColor(0);
        pdf.line(leftMargin, footerY, pdfWidth - margin, footerY);
      }
    }

    pdf.save(`WORK ORDER ANALYSIS SUMMARY REPORT.pdf`);
  };

  // Function for the excel
  // const exportToExcel = async () => {
  //   setLoading(true);
  //   if (data.length === 0) {
  //     return;
  //   }
  //   const reportLevel = level;
  //   if (reportLevel === 4) {
  //     const workbook = new ExcelJS.Workbook();
  //     const worksheet = workbook.addWorksheet('Report');

  //     // Set up the column widths
  //     worksheet.columns = [
  //       { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 },
  //       { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }
  //     ];

  //     // Add a heading
  //     worksheet.mergeCells('A2:J6');
  //     const titleCell = worksheet.getCell('A4');
  //     titleCell.value = 'WORK ORDER ANALYSIS SUMMARY REPORT';
  //     titleCell.font = { size: 15, bold: true };
  //     titleCell.alignment = { vertical: 'middle', horizontal: 'center' };

  //     // Define and add sections with formatting
  //     const sections = getLevel4Data;

  //     let titleRow = 8; // Start the first section after the heading

  //     // Function to add sections with data
  //     sections.forEach(section => {

  //       worksheet.addRow([]);
  //       worksheet.getRow(worksheet.lastRow.number).height = 15; // Adjust row height for visual spacing

  //       // Adding a section title with spacing
  //       worksheet.mergeCells(`A${titleRow}:J${titleRow}`);
  //       const sectionTitleCell = worksheet.getCell(`A${titleRow}`);
  //       sectionTitleCell.value = section.title || "Section Title";
  //       sectionTitleCell.font = { size: 14, bold: true };
  //       sectionTitleCell.alignment = { vertical: 'middle', horizontal: 'center' };
  //       sectionTitleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
  //       sectionTitleCell.border = {
  //         top: { style: 'thin' },
  //         left: { style: 'thin' },
  //         bottom: { style: 'thin' },
  //         right: { style: 'thin' },
  //       };

  //       // Add another empty row for spacing after the section title
  //       worksheet.addRow([]);
  //       worksheet.getRow(worksheet.lastRow.number).height = 15; // Adjust as needed


  //       // Add data rows for the section
  //       section.data.forEach(row => {
  //         const rowIndex = worksheet.addRow([]).number;

  //         row.forEach((value, columnIndex) => {
  //           const cell = worksheet.getCell(rowIndex, columnIndex + 1); // columnIndex + 1 because columns start at 1
  //           cell.value = value;

  //           // Apply styles
  //           cell.font = { size: 12 };
  //           cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
  //           cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } }; // White background
  //           cell.border = {
  //             top: { style: 'thin' },
  //             left: { style: 'thin' },
  //             bottom: { style: 'thin' },
  //             right: { style: 'thin' },
  //           };
  //         });

  //       });

  //       // Update titleRow for the next section
  //       titleRow += section.data.length + 3; // Move to the next section
  //     });
  //     try {
  //       // Generate and save the Excel file
  //       const buffer = await workbook.xlsx.writeBuffer();
  //       const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //       // Dynamically set the filename based on options
  //       let optionsLabel = commonTableDetails?.options || 'Default'; // Fallback if undefined
  //       optionsLabel = optionsLabel.replace(/[\/\\:*?"<>|]/g, ''); // Remove invalid filename characters

  //       const fileName = `Work Order Analysis ${optionsLabel} Report.xlsx`;
  //       saveAs(blob, fileName);
  //     } catch (error) {
  //       console.error('Error writing Excel file:', error);
  //     }


  //   }

  //   else {
  //     const workbook = new ExcelJS.Workbook();
  //     const worksheet = workbook.addWorksheet('Report');

  //     // // Add some empty rows for spacing
  //     // worksheet.addRow([]);
  //     // worksheet.addRow([]);
  //     // Exclude unnecessary fields from `commonTableDetails`
  //     delete commonTableDetails.WorkType;
  //     delete commonTableDetails.priority;
  //     delete commonTableDetails.title;
  //     const excludedFields = ['priority', 'WorkType'];

  //     // Filter the keys, removing excluded ones
  //     const originalKeys = Object.keys(commonTableDetails)
  //       .filter(key => key !== 'options' && !hiddenFields.includes(key));
  //     let finalKeys = originalKeys.filter(key => !excludedFields.includes(key));
  //     // Ensure options is included if it exists in commonTableDetails
  //     if (!finalKeys.includes('options') && commonTableDetails.hasOwnProperty('options')) {
  //       finalKeys.push('options');
  //     }
    

  //     // Prepare the export data
  //     const exportData = finalKeys.map(key => ({
  //       [key]: commonTableDetails[key] || '',
  //     }));
      
  //     // Prepare the table headers
  //     const tableHeaders = originalKeys.map(key => formatHeader(key));
   
  //     const tableData = [originalKeys.map(key => commonTableDetails[key] || '')
  //       .filter((_, index) => index !== 4 && index !== 5)];

  //     if (exportData[4]?.options === 'Summary') {
  //       // Add the table headers
  //       const headerRow = worksheet.addRow(tableHeaders);
  //       headerRow.font = { bold: true };

  //       // Add the table data
  //       tableData.forEach(row => {
  //         worksheet.addRow(row);
  //       });

  //     }

  //     // worksheet.addRow([]);

  //     // Define headers with formatting
  //     const agGridHeaders = Object.keys(data[0])
  //       .filter(key => key !== 'no' && !hiddenFields.includes(key))
  //       .map(key => formatHeader(key));

  //     // Add headers row
  //     const agGridHeaderRow = worksheet.addRow(agGridHeaders);
  //     agGridHeaderRow.font = { bold: true };

  //     agGridHeaderRow.eachCell(cell => {
  //       cell.alignment = { horizontal: 'center' }; // Center-align headers
  //     });

  //     data?.forEach(rowData => {
  //       const reorderedRow = Object.keys(rowData || {})
  //         .filter(key => key !== 'no' && !hiddenFields.includes(key)) // Exclude specific keys
  //         .map((key, index) => {
  //           let value = rowData[key];

  //           if (key.includes('Date') && value) {
  //             // try {
  //             //     const date = new Date(value);
  //             //     value = !isNaN(date.getTime())
  //             //         ? date.toLocaleDateString('en-GB')
  //             //         : value;
  //             // } catch (error) {
  //             //     console.error(`Error formatting date for key ${key}:`, error);
  //             // }
  //           } else if (key.includes('Time') && value) {
  //             try {
  //               const date = new Date(value);
  //               value = !isNaN(date.getTime())
  //                 ? date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
  //                 : value;
  //             } catch (error) {
  //               console.error(`Error formatting time for key ${key}:`, error);
  //             }
  //           } else if (key === 'respondDuration') {
  //             try {
  //               if (value === 0) {
  //                 value = 0; // Retain 0
  //               } else if (typeof value === 'string' && value.includes(':')) {
  //                 const [hours, minutes] = value.split(':').map(Number);
  //                 value = Math.round(hours * 60 + minutes);
  //               }
  //             } catch (error) {
  //               console.error(`Error converting respondDuration for key ${key}:`, error);
  //               value = '';
  //             }
  //           }

  //           // Fix: Use hospitalCode instead of initials from hospital
  //           if (index === 0 && rowData?.hospitalCode) {
  //             return rowData.hospitalCode;
  //           }

  //           return value ?? "";
  //         });






  //       const newRow = worksheet.addRow(reorderedRow);


  //       newRow.eachCell((cell, colIndex) => {
  //         const cellValue = reorderedRow[colIndex - 1]; // Get the value for this cell

  //         if (typeof cellValue === 'number') {
  //           // Apply numeric formatting and right alignment
  //           cell.alignment = { horizontal: 'right', vertical: 'middle' };
  //           cell.numFmt = '0'; // Format as integer (change to "0.00" for 2 decimal places)

  //           // Adjust the column width to fit the content
  //           const contentLength = cellValue.toString().length;
  //           const currentColumn = worksheet.getColumn(colIndex);
  //           const currentWidth = currentColumn.width || 10; // Default width
  //           currentColumn.width = Math.max(currentWidth, contentLength + 2); // Add padding
  //         } else {
  //           // Apply left alignment for text or other non-numeric values
  //           cell.alignment = { horizontal: 'left', vertical: 'middle' };

  //           // Adjust the column width for text content
  //           const contentLength = cellValue?.toString().length || 0;
  //           const currentColumn = worksheet.getColumn(colIndex);
  //           const currentWidth = currentColumn.width || 10; // Default width
  //           currentColumn.width = Math.max(currentWidth, contentLength + 2); // Add padding
  //         }
  //       });

  //     });

  //     // Calculate the maximum width for each column
  //     const maxColumnWidths = [];
  //     worksheet.columns.forEach((column, index) => {
  //       let maxLength = 0;
  //       column.eachCell({ includeEmpty: true }, cell => {
  //         const cellValue = cell.value ? cell.value.toString() : '';
  //         maxLength = Math.max(maxLength, cellValue.length);
  //       });
  //       column.width = maxLength + 2; // Add some padding to the width
  //       maxColumnWidths[index] = maxLength + 2;
  //     });

  //     // Apply basic styling to rows and cells
  //     worksheet.eachRow((row, rowNumber) => {

  //       row.eachCell((cell, colNumber) => {
  //         cell.border = {
  //           top: { style: 'thin' },
  //           left: { style: 'thin' },
  //           bottom: { style: 'thin' },
  //           right: { style: 'thin' },
  //         };
  //       });
  //     });

  //     const mergeStartColumn = agGridHeaderRow.cellCount + 1;
  //     const mergeEndColumn = mergeStartColumn + maxColumnWidths.length - 1;
  //     for (let i = 9; i <= 10; i++) {
  //       worksheet.mergeCells(i, mergeStartColumn, i, mergeEndColumn);
  //     }

  //     // Save the workbook to file
  //     try {
  //       // Generate and save the Excel file
  //       const buffer = await workbook.xlsx.writeBuffer();
  //       const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //       // Dynamically set the filename based on options
  //       let optionsLabel = commonTableDetails?.options || ''; // Fallback if undefined
  //       optionsLabel = optionsLabel.replace(/[\/\\:*?"<>|]/g, ''); // Remove invalid filename characters

  //       const fileName = `Work Order Analysis ${optionsLabel} Report.xlsx`;
  //       saveAs(blob, fileName);
  //     } catch (error) {
  //       console.error('Error writing Excel file:', error);
  //     }
  //   }
  //   setLoading(false);
  // }


  const exportToExcel = async () => {
    setLoading(true);
  
    try {
      if (!Array.isArray(data) || data.length === 0) {
        setLoading(false);
        return;
      }
  
      // Helper: write rating as richText stars into an ExcelJS cell
      function setRatingCell(cell, rawRating) {
        const maxStars = 5;
        let rating = Number(rawRating);
        if (!Number.isFinite(rating)) rating = 0;
        rating = Math.max(0, Math.min(maxStars, Math.floor(rating)));
  
        // ARGB colors (ExcelJS expects 8-digit ARGB)
        const gold = "FFFFD700"; // gold
        const gray = "FFBFBFBF"; // light gray
  
        const rich = [];
        for (let i = 0; i < rating; i++) {
          rich.push({ text: "★", font: { size: 12, color: { argb: gold } } });
        }
        for (let i = rating; i < maxStars; i++) {
          rich.push({ text: "☆", font: { size: 12, color: { argb: gray } } });
        }
  
        try {
          cell.value = { richText: rich };
          cell.alignment = { horizontal: "center", vertical: "middle" };
        } catch (e) {
          // fallback: plain text
          cell.value = "★".repeat(rating) + "☆".repeat(maxStars - rating);
          cell.alignment = { horizontal: "center", vertical: "middle" };
        }
      }
  
      const reportLevel = level;
  
      if (reportLevel === 4) {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Report");
  
        // Set up the column widths (you had 10 columns)
        worksheet.columns = [
          { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 },
          { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }
        ];
  
        // Add a heading
        worksheet.mergeCells("A2:J6");
        const titleCell = worksheet.getCell("A4");
        titleCell.value = "WORK ORDER ANALYSIS SUMMARY REPORT";
        titleCell.font = { size: 15, bold: true };
        titleCell.alignment = { vertical: "middle", horizontal: "center" };
  
        // Define and add sections with formatting
        const sections = getLevel4Data; // keep same variable name you had
  
        let titleRow = 8; // Start the first section after the heading
  
        // Function to append an empty spacer row
        function addSpacer() {
          worksheet.addRow([]);
          worksheet.getRow(worksheet.lastRow.number).height = 15;
        }
  
        sections.forEach(section => {
          addSpacer();
  
          // Section title row
          worksheet.mergeCells(`A${titleRow}:J${titleRow}`);
          const sectionTitleCell = worksheet.getCell(`A${titleRow}`);
          sectionTitleCell.value = section.title || "Section Title";
          sectionTitleCell.font = { size: 14, bold: true };
          sectionTitleCell.alignment = { vertical: "middle", horizontal: "center" };
          sectionTitleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD3D3D3" } };
          sectionTitleCell.border = {
            top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" }
          };
  
          addSpacer();
  
          // If section.headers exists use it to detect rating column index, else try to detect by value pattern
          const sectionHeaders = Array.isArray(section.headers) ? section.headers : null;
  
          // Add data rows for the section: section.data is expected as array of arrays (per your original)
          section.data.forEach(row => {
            // create new row index
            const rowIndex = worksheet.addRow([]).number;
  
            row.forEach((value, columnIndex) => {
              const cell = worksheet.getCell(rowIndex, columnIndex + 1);
  
              // Determine if this column is rating:
              const header = sectionHeaders ? sectionHeaders[columnIndex] : null;
              const isRatingColumn = header && String(header).trim().toLowerCase() === "rating";
  
              // Fallback: if header not available, detect rating if value is numeric between 0 and 5
              const fallbackIsRating = !isRatingColumn && (typeof value === "number" || (!isNaN(Number(value)) && value !== "")) && (() => {
                const n = Number(value);
                return Number.isFinite(n) && n >= 0 && n <= 5;
              })();
  
              if (isRatingColumn || fallbackIsRating) {
                setRatingCell(cell, value);
              } else {
                cell.value = value ?? "";
                cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
              }
  
              // Apply styles
              cell.font = { size: 12 };
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } }; // White background
              cell.border = {
                top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" }
              };
            });
          });
  
          // Update titleRow for the next section: add section.data length + some spacing
          titleRow += (section.data?.length || 0) + 3;
        });
  
        // Write workbook to file
        try {
          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let optionsLabel = commonTableDetails?.options || "Default";
          optionsLabel = optionsLabel.replace(/[\/\\:*?"<>|]/g, "");
          const fileName = `Work Order Analysis ${optionsLabel} Report.xlsx`;
          saveAs(blob, fileName);
        } catch (error) {
          console.error("Error writing Excel file:", error);
        }
  
      } else {
        // Non-level-4 export (your original branch)
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Report");
  
        // Clean commonTableDetails for export headers
        // Work on a shallow clone so you don't mutate original object unexpectedly
        const ctd = { ...(commonTableDetails || {}) };
        delete ctd.WorkType;
        delete ctd.priority;
        delete ctd.title;
        const excludedFields = ["priority", "WorkType"];
  
        // originalKeys includes keys excluding 'options' and hidden fields
        const originalKeys = Object.keys(ctd).filter(key => key !== "options" && !hiddenFields.includes(key));
        let finalKeys = originalKeys.filter(key => !excludedFields.includes(key));
        if (!finalKeys.includes("options") && ctd.hasOwnProperty("options")) {
          finalKeys.push("options");
        }
  
        // Prepare exportData and table headers
        const exportData = finalKeys.map(key => ({ [key]: ctd[key] || "" }));
        const tableHeaders = originalKeys.map(key => formatHeader(key));
  
        // Only add table headers & data if options summary (same logic as before)
        const tableData = [originalKeys.map(key => ctd[key] || "").filter((_, index) => index !== 4 && index !== 5)];
  
        if (exportData[4]?.options === "Summary") {
          const headerRow = worksheet.addRow(tableHeaders);
          headerRow.font = { bold: true };
          tableData.forEach(row => worksheet.addRow(row));
        }
  
        // Build agGrid headers and keysUsed mapping
        const agGridKeys = Object.keys(data[0] || {}).filter(key => key !== "no" && !hiddenFields.includes(key));
        const agGridHeaders = agGridKeys.map(key => formatHeader(key));
  
        // Add headers row
        const agGridHeaderRow = worksheet.addRow(agGridHeaders);
        agGridHeaderRow.font = { bold: true };
        agGridHeaderRow.eachCell(cell => { cell.alignment = { horizontal: "center" }; });
  
        // For each data row create reorderedRow using agGridKeys (preserve exact key order so keysUsed aligns)
        data.forEach(rowData => {
          const keysUsed = agGridKeys.slice(); // clone
  
          const reorderedRow = keysUsed.map((key, index) => {
            let value = rowData?.[key];
  
     

            if (key.includes('Date') && value) {
              // try {
              //     const date = new Date(value);
              //     value = !isNaN(date.getTime())
              //         ? date.toLocaleDateString('en-GB')
              //         : value;
              // } catch (error) {
              //     console.error(`Error formatting date for key ${key}:`, error);
              // }
            } else if (key.includes('Time') && value) {
              try {
                const date = new Date(value);
                value = !isNaN(date.getTime())
                  ? date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
                  : value;
              } catch (error) {
                console.error(`Error formatting time for key ${key}:`, error);
              }
            } else if (key === 'respondDuration') {
              try {
                if (value === 0) {
                  value = 0; // Retain 0
                } else if (typeof value === 'string' && value.includes(':')) {
                  const [hours, minutes] = value.split(':').map(Number);
                  value = Math.round(hours * 60 + minutes);
                }
              } catch (error) {
                console.error(`Error converting respondDuration for key ${key}:`, error);
                value = '';
              }
            }
  
            // Use hospitalCode instead of initials if provided (based on your original logic)
            if (index === 0 && rowData?.hospitalCode) {
              return rowData.hospitalCode ?? "";
            }
  
            return value ?? "";
          });
  
          // Add row to worksheet
          const newRow = worksheet.addRow(reorderedRow);
  
          // Apply formatting to each cell and detect rating column to set stars
          newRow.eachCell((cell, colIndex) => {
            const cellValue = reorderedRow[colIndex - 1];
            const correspondingKey = keysUsed[colIndex - 1];
  
            // Determine if this column is rating
            const isRating = correspondingKey && String(correspondingKey).trim().toLowerCase() === "rating";
  
            if (isRating) {
              setRatingCell(cell, cellValue);
              // apply border and continue to next cell
              cell.border = {
                top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" }
              };
              return;
            }
  
            // Numeric formatting
            if (typeof cellValue === "number") {
              cell.alignment = { horizontal: "right", vertical: "middle" };
              cell.numFmt = "0"; // integer style; change to "0.00" for two decimals if needed
  
              const contentLength = cellValue.toString().length;
              const currentColumn = worksheet.getColumn(colIndex);
              const currentWidth = currentColumn.width || 10;
              currentColumn.width = Math.max(currentWidth, contentLength + 2);
            } else {
              // Text alignment and sizing
              cell.alignment = { horizontal: "left", vertical: "middle" };
              const contentLength = cellValue?.toString().length || 0;
              const currentColumn = worksheet.getColumn(colIndex);
              const currentWidth = currentColumn.width || 10;
              currentColumn.width = Math.max(currentWidth, contentLength + 2);
            }
  
            // Apply borders
            cell.border = {
              top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" }
            };
          });
        });
  
        // Calculate the maximum width for each column (safety)
        const maxColumnWidths = [];
        worksheet.columns.forEach((column, index) => {
          let maxLength = 0;
          column.eachCell({ includeEmpty: true }, cell => {
            const cellValue = cell.value ? (typeof cell.value === "object" && cell.value.richText ? cell.value.richText.map(rt => rt.text).join("") : cell.value.toString()) : "";
            maxLength = Math.max(maxLength, cellValue.length);
          });
          column.width = maxLength + 2;
          maxColumnWidths[index] = maxLength + 2;
        });
  
        // Apply borders to all cells (already mostly applied, but reinforce)
        worksheet.eachRow((row) => {
          row.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" }
            };
          });
        });
  
        // Some existing merge logic you had — preserve but guard indexes
        const mergeStartColumn = agGridHeaderRow.cellCount + 1;
        const mergeEndColumn = mergeStartColumn + maxColumnWidths.length - 1;
        for (let i = 9; i <= 10; i++) {
          try {
            worksheet.mergeCells(i, mergeStartColumn, i, mergeEndColumn);
          } catch (e) {
            // ignore merge errors if indices out of range
          }
        }
  
        // Save workbook
        try {
          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let optionsLabel = commonTableDetails?.options || "";
          optionsLabel = optionsLabel.replace(/[\/\\:*?"<>|]/g, "");
          const fileName = `Work Order Analysis ${optionsLabel} Report.xlsx`;
          saveAs(blob, fileName);
        } catch (error) {
          console.error("Error writing Excel file:", error);
        }
      }
    } catch (err) {
      console.error("Unexpected error in exportToExcel:", err);
    } finally {
      setLoading(false);
    }
  };
  
  // function for reports Print
  const onPrint = async () => {
    const originalPagination = pagination;
    setPagination(false);

    await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for grid to re-render without pagination

    const pdf = new jsPDF();
    pdf.setFontSize(10);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 17;
    const leftMargin = 17;
    const adjustedPdfWidth = pdfWidth - leftMargin - margin;
    const topMargin = 35;

    // Ensure refData is an array
    if (!Array.isArray(data)) {
      setPagination(originalPagination);
      return;
    }

    const flattenData = (refData) => {
      return refData.map(row => {
        const flatRow = {};
        Object.keys(row).forEach(key => {
          if (typeof row[key] === 'object' && !Array.isArray(row[key])) {
            Object.keys(row[key]).forEach(subKey => {
              flatRow[`${key} - ${subKey}`] = row[key][subKey];
            });
          } else {
            flatRow[key] = row[key];
          }
        });
        return flatRow;
      });
    };

    // Flatten the refData
    const flattenedData = flattenData(data);

    if (flattenedData.length === 0) {
      setPagination(originalPagination);
      return;
    }

    // Modify headers and rows: Move "no" column to the first position and capitalize "no" values
    const headers = Object.keys(flattenedData[0])
      .filter(header => !hiddenFields.includes(header));

    const modifiedHeaders = ["No", ...headers.filter(header => header !== "no").map(header => formatHeader(header))];


    const rows = flattenedData.map((row, index) => {
      const filteredRow = headers.map(header => {
        let cell = row[header];
        // Check if the cell is a date string and format it
        if (typeof cell === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(cell)) {
          cell = moment(cell).format('DD/MM/YYYY'); // Format the date
        }
        return cell;
      });

      return [
        { content: index + 1, styles: { halign: 'center', fontSize: 7 } }, // Row number
        ...filteredRow.map(cell => ({
          content: cell,
          styles: {
            halign: typeof cell === 'number' || !isNaN(cell) ? 'right' : 'center', // Right align for numbers
            fontSize: 7,
          },
        })),
      ];
    });


    // Generate the primary and secondary headers
    const primaryHeaders = [];
    const secondaryHeaders = [];
    let hasSecondaryHeaders = false;

    modifiedHeaders.forEach(header => {
      const parts = header.split(" - ");
      if (parts.length > 1) {
        if (!primaryHeaders.includes(parts[0])) {
          primaryHeaders.push(parts[0]);
          secondaryHeaders.push([]);
        }
        const parentIndex = primaryHeaders.indexOf(parts[0]);
        secondaryHeaders[parentIndex].push(parts[1]);
        hasSecondaryHeaders = true;
      } else {
        primaryHeaders.push(header);
        secondaryHeaders.push([]);
      }
    });

    const tableHeaders = hasSecondaryHeaders ? [
      primaryHeaders.map(header => {
        if (header === "Completed") {
          return { content: header, colSpan: 2, styles: { halign: 'center' } };
        }
        return { content: header, rowSpan: 2, styles: { halign: 'center' } };
      }),
      secondaryHeaders.flat().map(subHeader => subHeader ? { content: subHeader } : { content: '' })
    ] : [
      primaryHeaders.map(header => ({ content: header, styles: { halign: 'center' } }))
    ];

    const drawHeader = (pdf, pageNumber) => {
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(10);
      pdf.text("WORK ORDER ANALYSIS SUMMARY REPORT", 105, 20, { align: "center" });

      pdf.setFont("helvetica", "normal");
      pdf.addImage(reportslogo, "PNG", pdfWidth - 47, 10, 30, 18);
      pdf.setLineWidth(0.5);
      pdf.setDrawColor(0);
      const headerBottomY = 33;
      pdf.line(leftMargin, headerBottomY, pdfWidth - margin, headerBottomY);
    };

    // Specific layout for level 4
    if (level === 4) {
      drawHeader(pdf, 1);

      // Convert first table element to image
      const tableElement1 = document.querySelector(".table-container");
      const canvas1 = await html2canvas(tableElement1);
      const imgData1 = canvas1.toDataURL("image/png");
      const imgHeight1 = (canvas1.height * adjustedPdfWidth) / canvas1.width;

      // Add first table image to PDF
      pdf.addImage(imgData1, "PNG", leftMargin, topMargin, adjustedPdfWidth, imgHeight1);

      // Convert second table element to image
      const tableElement2 = document.querySelector(".finalreport-table-container");
      const canvas2 = await html2canvas(tableElement2);
      const imgData2 = canvas2.toDataURL("image/png");
      const imgHeight2 = (canvas2.height * adjustedPdfWidth) / canvas2.width;

      // Check if the second table fits on the current page, otherwise add a new page
      let currentY = topMargin + imgHeight1 + 5; // Adjust 10 for spacing between tables
      if (currentY + imgHeight2 > pdfHeight - margin) {
        pdf.addPage();
        currentY = topMargin;
      }

      // Add second table image to PDF
      pdf.addImage(imgData2, "PNG", leftMargin, currentY, adjustedPdfWidth, imgHeight2);

      const totalPages = pdf.internal.getNumberOfPages();
      const dateStr = new Date().toLocaleString();

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        const pageStr = `Date & Time: ${dateStr}`;
        const pageNumStr = `Page ${i} of ${totalPages}`;
        pdf.text(pageStr, margin, pdfHeight - 10);
        pdf.text(pageNumStr, pdfWidth - pdf.getTextWidth(pageNumStr) - margin, pdfHeight - 10);
        const footerY = pdf.internal.pageSize.height - 14;
        pdf.setLineWidth(0.5);
        pdf.setDrawColor(0);
        pdf.line(leftMargin, footerY, pdfWidth - margin, footerY);
      }

      pdf.autoPrint();
      window.open(pdf.output("bloburl"), "_blank");

      setPagination(originalPagination);
    } else {
      // Default layout for other levels
      drawHeader(pdf, 1);

      const tableElement = document.querySelector(".table-container");
      const canvas = await html2canvas(tableElement);
      const imgData = canvas.toDataURL("image/png");
      const imgHeight = (canvas.height * adjustedPdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", leftMargin, topMargin, adjustedPdfWidth, imgHeight);

      pdf.autoTable({
        head: tableHeaders,
        body: rows,
        startY: topMargin + imgHeight + 1,
         theme: "striped",
        styles: {
          fontSize: 8,
          lineColor: [192, 192, 192],
          lineWidth: 0.5,
          cellPadding: 2,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
        },
        tableWidth: adjustedPdfWidth,
        headStyles: { fillColor: '#152B75', textColor: [255, 255, 255] },
        margin: { left: leftMargin, top: 35 },
        columnStyles: {
          0: { cellWidth: 'auto' },
        },
        didDrawPage: function (refData) {
          drawHeader(pdf, refData.pageNumber);
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      const dateStr = new Date().toLocaleString();

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        const pageStr = `Date & Time: ${dateStr}`;
        const pageNumStr = `Page ${i} of ${totalPages}`;
        pdf.text(pageStr, margin, pdfHeight - 10);
        pdf.text(pageNumStr, pdfWidth - pdf.getTextWidth(pageNumStr) - margin, pdfHeight - 10);
        const footerY = pdf.internal.pageSize.height - 14;
        pdf.setLineWidth(0.5);
        pdf.setDrawColor(0);
        pdf.line(leftMargin, footerY, pdfWidth - margin, footerY);
      }

      pdf.autoPrint();
      window.open(pdf.output("bloburl"), "_blank");

      setPagination(originalPagination);
    }
  };
  // useEffect(() => {
  //   console.log(workOrder, "Updated workOrder");
  // }, [workOrder]);

  useEffect(() => {
    // When the selectedWorkOrder changes, update dateOption accordingly
    if (selectedWorkOrder === "All") {
      setDateOption(""); // Reset dateOption for "All"
    } else if (selectedWorkOrder === "Unscheduled") {
      setDateOption("Work order Date"); // Set to "Work order Date"
    } else if (selectedWorkOrder === "Scheduled") {
      setDateOption("Target Date"); // Set to "Target Date"
    }
  }, [selectedWorkOrder]);
 
  return (
    <>
      <PageLoader open={loading} />
      <Box mt={{ xs: 1, sm: 2 }}>
        <Stack direction={"row"} alignItems={"center"}>
          <PageTitle title="Work Order Analysis Report" />
        </Stack>
        <DefaultCard>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography variant="h5">Filter Details</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Level"
                value={levellist}
                options={levelname}
                onChange={(e) => {
                  handleOnChange("Level", (e));
                  console.log(levellist, "levellist");
                  console.log(e, "e");
                  if(e.label == "HQ")
                  {
                    setDisabled(true);
                    setHospitalList([]);
                  }else{
                    setDisabled(false);
                    setHospitalList(hospitalListOptions[0]);

                  }
                  
                }}
                disabled={level !== 1 || !(access?.canEdit)} // Disable if level is not 1
                errorMessage={errors.level}
                error={!!errors.Level}
                isMandatoryField={true}
                defaultOption={levelname[0]}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Options"
                value={filterDetailsData?.options || ""}
                disabled={level !== 1}
                options={optionsname}
                onChange={(newvalue) => {
                  handleOnChange("options", newvalue);
                }}
                isMandatoryField={true}
              // defaultOption={optionsname[0]}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Hospital"
                value={
                  hospitalList
                }
                options={hospitalListOptions}
                onChange={(e) => {
                  handleOnChange("hospitalName", (e));
                }}
                disabled={level !== 1 || !(access?.canEdit) || disabled} // Disable if level is not 1
                errorMessage={errors.hospitalName}
                error={!!errors.hospitalName}
                isMandatoryField={!disabled}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Service"
                value={
                  serviceTypeOptions?.value
                }
                options={serviceTypeOptions}
                onChange={(e) => {
                  handleOnChange("serviceId", e);
                }}
                disabled={level !== 1} // Disable if level is not 1
                errorMessage={errors.serviceId}
                error={errors.serviceId}
                isMandatoryField={true}
              />
            </Grid>


            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="service-type-label"
                label="Work Order"
                isMandatoryField={true}
                value={selectedWorkOrder} // Bind to state
                autoFocus={true}
                options={workOrder} // Dynamically fetched options
                errorMessage={errors.workordercategory}
                error={errors.workordercategory}
                onChange={(newValue) => {
                  // setSelectedWorkOrder(newValue?.value); // Update work order state


                  // Handle any other logic for onChange
                  handleOnChange("workordercategory", newValue);
                }}
                disabled={level !== 1} // Disable if level is not 1
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="priority"
                label="Priority"
                isMandatoryField={true}
                value={filterDetailsData?.priority?.value}  // Bind value from filterDetailsData state
                options={priorityTypeOption}  // This should be an array of objects [{ label: 'All', value: null }, { label: 'Normal', value: 1 }]
                errorMessage={errors?.priority}  // Show error message for priority if exists
                error={!!errors?.priority}  // Trigger error if there's an error
                onChange={(newValue) => {
                  handleOnChange("priority", newValue);  // Pass selected value to handleOnChange
                }}
                disabled={level !== 1}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="service-type-label"
                label="Group By"
                isMandatoryField={true}
                value={filterDetailsData?.groupBy || ""}
                // value={workGroupOptions?.value}
                autoFocus={true}
                options={workGroupOptions ? workGroupOptions : []}
                errorMessage={errors.groupBy}
                error={!!errors.groupBy}
                onChange={(newValue) => {
                  handleOnChange("groupBy", newValue);
                }}
                disabled={level !== 1 || filterDetailsData?.workordercategory === 3 ? true : false || filterDetailsData?.options?.id === 2 ? true : false} // Disable if level is not 1
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomMultiSelect
                id="wo-type"
                label="WO Type"
                isMandatoryField={true}
                values={filterDetailsData?.workOrderType || []} // Full objects
                // values={woTypeValue} // Full objects
                options={woType}
                onChange={(newValue) => {
                  if (newValue) {
                    handleMultiSelectChange("workOrderType", newValue);
                  }
                }}
                error={!!errors.workOrderType}
                helperText={errors.workOrderType}
                disabled={level !== 1} // Disable if level is not 1

              />

            </Grid>
            {selectedWorkOrder !== "All" && (
              <Grid item xs={16} md={4}>
                <FormControl component="fieldset" disabled={selectedWorkOrder === "All"}
                >
                  <Typography variant="labelSm" color="text.primary" component="label">
                    Date Options
                  </Typography>
                  <RadioGroup
                    name="dateOptions"
                    value={dateOption} // Bind to state
                    onChange={(event) => setDateOption(event.target.value)} // Update state on change
                    style={{ display: "flex", flexDirection: "row" }}
                  >
                    {/* Option for Work Order Date */}
                    <FormControlLabel
                      value="Work order Date"
                      control={<Radio style={{ color: "inherit" }} />}
                      label="Work order Date"
                      disabled={selectedWorkOrder !== "Unscheduled"} // Enable only for "Unscheduled"
                    />
                    {/* Option for Target Date */}
                    <FormControlLabel
                      value="Target Date"
                      control={<Radio style={{ color: "inherit" }} />}
                      label="Target Date"
                      disabled={selectedWorkOrder !== "Scheduled"} // Enable only for "Scheduled"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={6} md={4}>
              <CustomDatePicker
                label="From Date"
                name="fromDate"
                error={!!errors.fromDate}
                isStartDate={true}
                disablePastDate={true}
                maxDate={currentDate}
                id={"from-date"}
                errorMessage={errors.fromDate}
                isMandatoryField={true}
                value={fromDate}
                onDateChange={(newValue) => {
                  setFromDate(newValue);
                  handleOnChange("fromDate", newValue);
                }}
                disabled={level !== 1} // Disable if level is not 1
              // onDateChange={handleEffectiveFromDateChange}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomDatePicker
                name="toDate"
                label="To Date"
                isStartDate={true}
                disablePastDate={true}
                // maxDate={currentDate}
                id={"to-date"}
                isMandatoryField={true}
                value={toDate}

                errorMessage={errors.toDate}
                error={!!errors.toDate}
                onDateChange={(newValue) => {
                  handleOnChange("toDate", newValue);
                }}
                disabled={level !== 1} // Disable if level is not 1
              />
            </Grid>
          </Grid>

          <Grid item xs={6} md={2}>
            <Box
              sx={{
                marginTop: "10px",
                display: "flex",
                gap: 2,
                justifyContent: { xs: "center", md: "end" },
              }}
            >
              <Button variant="contained" onClick={handleGetResults}>
                Get Results
              </Button>
              <Button sx={{ border: "1px solid" }} onClick={() => window.location.reload()}  >
                REFRESH
              </Button>
            </Box>
          </Grid>
        </DefaultCard>
      </Box>

      <div className="button-container">
        <Stack direction={"row"} alignItems={"flex-end"}>
          <Tooltip
            title="back"
            placement="bottom"
            arrow
            disableFocusListener
            disableInteractive
          >
            <IconButton onClick={handleBackClick} disabled={!canGoBack}>
              <ArrowBackRoundedIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Refresh" placement="bottom" arrow disableFocusListener disableInteractive>
            <IconButton
              onClick={currentHandleGridRefresh}
        
            >
              <LoopRoundedIcon />
            </IconButton>
          </Tooltip>

        </Stack>


        {access?.canPrint && (
          <WorkOrderRefreshExportButtons
            exportToExcel={exportToExcel}
            exportPDF={exportPDF}
            onPrint={onPrint}
            disablePdfPrinter={(level === 3 && filterDetailsData?.options?.value === 2) ? true : false}
          />
        )}

      </div>
      <DefaultCard mt={{ xs: 1, sm: 2 }}>
        <div id="printableAreas">
          <div className="grid-header">
            <div className="logo-container">

              <p className="title-text">
                WORK ORDER ANALYSIS{" "}
                {filterDetailsData?.options?.value === 1
                  ? "SUMMARY"
                  : filterDetailsData?.options?.value === 2
                    ? "DETAILS"
                    : ""}{" "}
                REPORT
              </p>

              {/* <p className="title-text"> WORK ORDER ANALYSIS SUMMARY REPORT</p>  */}
              <img src={reportslogo} alt="logo3" className="logo3" />
            </div>
          </div>


          <table className="table-container">
            <thead>
              <tr>
                <th>Hospital</th>
                <td>{filterDetailsData?.Level == "HQ" ? "All" : commonTableLabel?.Hospital || ""}</td>
                <th>Service</th>
                <td>
                  {commonTableLabel?.Service || ""}
                </td>
                <th>From Date</th>
                <td>
                  {commonTableLabel?.FromDate || ""}
                </td>
                <th>To Date</th>
                <td colSpan="3">
                  {commonTableLabel?.ToDate || ""}
                </td>
              </tr>
              <tr>
                <th>Work Type</th>
                <td colSpan={7}>
                  {/* {commonTableLabel?.WorkType || (matchingWoType ? matchingWoType.label : "")} */}
                  {/* {matchingWoType ? matchingWoType.label : ""}  */}
                  {
                    filterDetailsData?.workOrderType?.some((item) => item.label === "All")
                      ? "All" // If any label is "All", show only "All"
                      : filterDetailsData?.workOrderType?.map((item) => item.label).join(", ") || "" // Otherwise, show comma-separated labels
                  }

                </td>
              </tr>
            </thead>
          </table>
        </div>


        <Box mt={{ xs: 1, sm: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {loading ? "" :
                level === 4 && leveldata?.length > 0 ? (
                  <WorkorderFinalreport
                    finalReportDetails={leveldata}
                    workOrderType={leveldata?.[0]?.workordercategory === "Unscheduled"
                      ? 1
                      : leveldata?.[0]?.workordercategory === "Scheduled"
                        ? 2
                        : filterDetailsData?.workordercategory
                          ? filterDetailsData?.workordercategory
                          : 3}
                    serviceType={servicelevel?.service}
                    facilityId={filterDetailsData?.hospitalid ? filterDetailsData?.hospitalid : 0}
                    facilityname={filterDetailsData?.hospitalName ? filterDetailsData?.hospitalName : 0}
                  />
                ) : level !== 4 && data && data.length > 0 ? (
                  <CustomAgGrid
                    gridRefs={gridApi}
                    setGridApi={setGridApi}
                    rows={data}
                    columns={columns}
                    isEnableView={false}
                    pageName={"Reports"}
                  />
                ) : (
                  <Typography variant="h6" align="center">
                    No records found
                  </Typography>
                )}
            </Grid>
            {/* <Grid item xs={12}>
              {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CircularProgress /> <h4> Loading ...</h4>
                </Box>
              ) :
                level === 4 && leveldata?.length > 0 ? (
                  <WorkorderFinalreport
                    finalReportDetails={leveldata}
                    workOrderType={
                      filterDetailsData?.workordercategory
                        ? filterDetailsData?.workordercategory: 3
                    }
                    serviceType= {servicelevel?.service}
                    facilityId={filterDetailsData?.hospitalid ? filterDetailsData?.hospitalid : 0}
                    facilityname={filterDetailsData?.hospitalName ? filterDetailsData?.hospitalName: 0}
                  />
                ) : level !== 4 && data && data.length > 0 ? (
                  <CustomAgGrid
                    ref={gridRef}
                    setGridApi={setGridApi}
                    rows={data}
                    columns={columns}
                    isEnableView={false}
                    disableFilter={true}
                    pageName={"Reports"}
                    // resizable={false}
                  />
                ) : (
                  <Typography variant="h6" align="center">
                    No records found
                  </Typography>
                )}
            </Grid> */}
          </Grid>
        </Box>
      </DefaultCard>
    </>
  );
};

export default Reports
